import Vue from 'vue'
import Router from 'vue-router'
import MainView from './views/MainView.vue'
import Single from './views/Single.vue'
import SingleViewWyzwania from './views/SingleViewWyzwania.vue'
import SingleViewSniadania from './views/SingleViewSniadania.vue'
import FileExpired from './views/FileExpired.vue'
import PageNotFound from './views/PageNotFound.vue'
import VueScrollTo from 'vue-scrollto'
import { defaultLocale } from './lang.js'
import { locale } from './lang.js'

Vue.use(Router)

const publicPath = (process.env.VUE_APP_PUBLIC_PATH === undefined || process.env.VUE_APP_PUBLIC_PATH === null) ? '/' : process.env.VUE_APP_PUBLIC_PATH

export default new Router({
    mode: 'history',
    base: locale != defaultLocale ? publicPath + locale + '/' : publicPath,
    routes: [
        { path: '/'+defaultLocale, redirect: { name: 'home' } },
        { path: '/'+defaultLocale+'/:id', redirect: '/:id' },
        { path: '/'+defaultLocale+'/:parent/:id', redirect: '/:parent/:id' },
        { path: '/', name: 'home', component: MainView, props: true },
        { path: '/file-expired', component: FileExpired },
        { path: '/wyzwania/:id', component: Single },
        { path: '/challenges/:id', component: Single },
        // { path: '/wyzwania/:id', component: SingleViewWyzwania },
        // { path: '/challenges/:id', component: SingleViewWyzwania },
        // { path: '/sniadania/:id', component: SingleViewSniadania },
        { path: '/:parent/:id', component: MainView, props: true },
        { path: '/', redirect: { name: 'home' } },
        { path: '*', component: PageNotFound },
    ],
    scrollBehavior(to) {
        if (to.hash) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    VueScrollTo.scrollTo(to.hash, 1000);
                    resolve({ selector: to.hash })
                }, 1000)
            })
        } else {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve({ x: 0, y: 0 })
                }, 600)
            })
        }
    }
})
